const FEDERATION_SUPPORTED_TYPES = [
    'script'
];

export { FEDERATION_SUPPORTED_TYPES };
